<template>
  <div>
    <transition-group
      name="list-complete"
    >
      <div
        v-for="menuItem in menuItems"
        :key="menuItem.id || menuItem.category"
        class="list-complete-item"
        :class="{ 'col text-center': stackText }"
        data-test-id="desktop-navigation"
      >
        <q-btn
          v-if="menuItem.items"
          flat
          dense
          class="dropdown"
          :class="{
            'stacked': stackText,
            [hoverStyle]: true
          }"
          :icon-right="stackText ? 'expand_more' : 'expand_more'"
          :label="menuItem.category"
        >
          <q-menu
            bordered
            overlay
            anchor="bottom middle"
            self="top middle"
            :offset="[0, 5]"
          >
            <q-list>
              <q-item
                v-for="(item, itemIndex) in menuItem.items"
                :key="itemIndex"
                v-ripple
                class="text-white bg-secondary"
                clickable
                exact
                @click="item.navigateToRedirect($router)"
              >
                <q-item-section>
                  {{ item.name }}
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>
        <q-btn
          v-else
          flat
          dense
          :class="{
            'stacked': stackText,
            [hoverStyle]: true
          }"
          :label="menuItem.title"
          @click="menuItem.navigateToRedirect($router)"
        />
      </div>
    </transition-group>
  </div>
</template>

<script>

import { groupByCategory } from 'src/models/page/Navigation'
export default {
  name: 'DesktopNavigations',
  configuration: ['navigations'],
  props: {
    showFirstChunk: {
      type: Boolean,
      default: false
    },
    showSecondChunk: {
      type: Boolean,
      default: false
    },
    stackText: {
      type: Boolean,
      default: false
    },
    hoverStyle: {
      type: String,
      default: null
    }
  },
  computed: {
    navigationList () {
      const pageMenuItems = _.filter(this.navigations?.data, navigation => navigation.visible && !navigation.isArchived && (navigation.showInHeader || navigation.showInMenu))

      if (!pageMenuItems) return []

      return pageMenuItems
    },
    headerList () {
      if (this.$q.screen.lt.md) return []

      const headerMenuItems = this.navigationList.filter(navigation => navigation.visible && navigation.showInHeader)

      return groupByCategory(headerMenuItems)
    },
    menuItems () {
      if (!this.showFirstChunk && !this.showSecondChunk) return this.headerList
      const chunks = this.chunkArray(this.headerList, 2)
      if (this.showFirstChunk) {
        return chunks[0] || []
      } else {
        return chunks[1] || []
      }
    }
  },
  methods: {
    chunkArray (arr, n) {
      const chunkSize = Math.ceil(arr.length / n)
      const chunks = []
      for (let i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize))
      }
      return chunks
    }
  }
}
</script>
